import type { BibleLocation } from '@skjv/common';

/** Parse a verse DOM id like "v-0-1-2-3" into a BibleLocation */
export function parseVerseId(id: string): BibleLocation {
  const parts = id.replace('v-', '').split('-').map(Number);
  return {
    testamentIndex: parts[0],
    bookIndex: parts[1],
    chapterIndex: parts[2],
    verseIndex: parts[3],
  };
}
